<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2023-08-02 14:07:33
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-04-23 14:49:57
 * @FilePath: /wemeet-iam/Users/hvv/weMeetSpace/wemeet-poster/src/views/register-form/staticQuestionnaire.vue
 * @Description: 
 * Copyright (c) 2024 by WeMeet, All Rights Reserved. 
-->
<template>
  <div class="container staticQuestionaireBox">
    <div class="demo-ruleForm">
    <div v-if="!status">
      <div class="topBox">
        <img :src="basicData.coverUrl" alt="" class="topImg">
        <el-card shadow="always" class="topCard">
          <h1>{{ basicData.title }}</h1>
          <p v-html="basicData.description"></p>
        </el-card>
      </div>

      <el-form ref="formRef" label-width="80px" label-position='top' style="margin-top:40px;">
        <!-- :rules="ruleForms" -->
        <template v-for="(item, index) in customFiledArr">
          <template v-if="item.type == 'input'">
            <el-form-item :label="(index + 1) + '.' + item.label" :key="item.index" :required="item.required">
              <el-input v-model="item.value" :placeholder="item.message"></el-input>
            </el-form-item>
          </template>

          <template v-if="item.type == 'numberInput'">
            <el-form-item :label="(index + 1) + '.' + item.label" :key="item.index" :required="item.required">
              <el-input v-model="item.value" type="number" :placeholder="item.message"></el-input>
            </el-form-item>
          </template>

          <template v-if="item.type == 'checkBox'">
            <el-form-item :label="(index + 1) + '.' + item.label" :required="item.required">
              <el-checkbox-group v-model="item.value">
                <template v-for='(sitem, sindex) in item.child'>
                  <el-checkbox :label="sitem.label" :name='sitem.formKey'
                    @change="checkBoxChange(sitem, index)"></el-checkbox>
                </template>
                <el-input v-if="item.showInp" placeholder="请输入" v-model="item.otherWord"></el-input>
              </el-checkbox-group>
            </el-form-item>
          </template>

          <template v-if="item.type == 'radio'">
            <el-form-item :label="(index + 1) + '.' + item.label" :required="item.required">
              <el-radio-group v-model="item.value">
                <template v-for='(sitem, sindex) in item.child'>
                  <el-radio :label="sitem.label" :name='sitem.formKey' @change="radioChange(sitem, index)"></el-radio>
                </template>
              </el-radio-group>
              <el-input v-if="item.showInp" placeholder="请输入" v-model="item.otherWord"></el-input>
            </el-form-item>
          </template>

          <template v-if="item.type == 'timePicker'">
            <el-form-item :label="(index + 1) + '.' + item.label" :required="item.required">
              <el-date-picker v-model="item.value" type="date" :placeholder="item.message">
              </el-date-picker>
            </el-form-item>
          </template>
          <template v-if="item.type == 'select'">
            <el-form-item :label="(index + 1) + '.' + item.label" :required="item.required">
              <el-select v-model="item.value" :placeholder="item.message">
                <el-option v-for='(sitem, sindex) in item.child' :key="sitem.formKey" :label="sitem.label"
                  :value="sitem.label">
                </el-option>
              </el-select>
            </el-form-item>
          </template>
          <template v-if="item.type == 'textarea'">
            <el-form-item :label="(index + 1) + '.' + item.label" :required="item.required">
              <el-input type="textarea" v-model="item.value" :maxlength="item.maxlength" show-word-limit
                :placeholder="item.message"></el-input>
            </el-form-item>
          </template>

          <!-- 定制模块区域 -->
          <!-- 展商选择器 -->
          <template v-if="item.type == 'exh_customized'">
            <el-form-item :label="(index + 1) + '.' + item.label" :required="item.required">
              <el-select v-model="item.value" placeholder="请选择" filterable>
                <el-option v-for='(sitem, sindex) in exhData' :key="sitem.formKey" :label="sitem.label"
                  :value="sitem.label">
                </el-option>
              </el-select>
            </el-form-item>
          </template>

          <!-- 团组选择器 -->
          <template v-if="item.type == 'group_customized'">
            <el-form-item :label="(index + 1) + '.' + item.label" :required="item.required">
              <el-select v-model="item.value" placeholder="请选择" filterable>
                <el-option v-for='(sitem, sindex) in groupData' :key="sitem.formKey" :label="sitem.label"
                  :value="sitem.label">
                </el-option>
              </el-select>
            </el-form-item>
          </template>

        </template>
        <el-form-item style="display:flex;justify-content: center;">
          <el-button type="primary" @click="onSubmit">提交</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div v-if='status' style="text-align:center;padding: 120px 30px 0 30px; ">
      <img src="../../../public/images/bigRight.png" alt="" style="width:64px;height:64px; margin: 0 auto;">
      <div style="font-size: 22px;font-weight: 500;color: #2F2F2F;margin-top:15px;margin-bottom:35px;">
        问卷提交成功
      </div>
    </div>

  </div>
  </div>
</template>


<script>
import { GetQueryString } from '@/utils/utils'
import { getQuestioniareInfo, noTokenQuestionnaireAdd, checkSubmitNaire } from '@/api/questionApi'
import formValite from '@/utils/form'
export default {
  name: 'test',
  data() {
    return {
      starIcon: 'https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/MEHZ/images/needForm.png',
      customFiledArr: [],
      code: '',
      form: {},
      ruleForms: {},
      basicData: {},
      exhData: [],
      groupData: [],
      status: false,
      submitFlag: false,
    }
  },
  created() {
    this.code = GetQueryString('code')
    this.getInfo(this.code)
    this.getStaticData()
  },
  methods: {
    getStaticData() {
      const config = {
        method: 'get',
        url: `https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/MEHZ/data/formDataJson.json`,
      }
      this.$http(config).then((res) => {
        let { exhData, groupData } = res.data
        this.exhData = this.handleSelectData(exhData)
        this.groupData = this.handleSelectData(groupData)
      })
    },
    handleSelectData(str) {
      let oArr = str.split('，')
      let nArr = []
      for (let i of oArr) {
        let obj = {}
        obj.label = i
        obj.formKey = `formKey` + Math.floor(Math.random(30) * 1000000000)
        nArr.push(obj)
      }
      return nArr
    },
    validator(val) {
      return /1\d{10}/.test(val)
    },
    radioBoxChange() { },
    valueChange(key, value) {
      this.form[key] = value
    },
    getInfo(code) {
      console.log(code)
      var headerClientInfo = { language: 'CN', eventKey: 'MEHZ', appKey: 'WX_MINI_MEHZ' }
      let headers = {
        'x-call-client-info': JSON.stringify(headerClientInfo),
      }
      getQuestioniareInfo(headers, code).then((res) => {
        this.basicData = res.data
        this.customFiledArr = JSON.parse(res.data.questionContent)
        this.generateKey()
        console.log(this.customFiledArr, this.ruleForms)
      })
    },
    onSubmit() {
      console.log(this.customFiledArr)
      console.log()

      if (this.submitFlag) {
        return false
      }

      if (!this.validateForm(this.customFiledArr)) {
        return false
      }

      let formContentArr = []

      formContentArr = formValite.handleFormAttendKeyByQuestionByNew(formContentArr, this.customFiledArr)
      console.log(formContentArr)

      // let subTime = {
      //   questionValue: ,
      //   questionName: "提交时间"
      // }

      let isSearchKey = this.customFiledArr.filter((v) => v.isSearch)
      let channelName = ''
      if (isSearchKey && isSearchKey.length > 0) {
        for (let i of isSearchKey) {
          console.log(i)
          channelName += i.value
        }
      }

      const data = {
        feedbackCode: this.code,
        feedbackContent: JSON.stringify(formContentArr),
        feedbackName: this.basicData.title,
        channel: channelName,
      }
      var headerClientInfo = { language: 'CN', eventKey: 'MEHZ', appKey: 'WX_MINI_MEHZ' }
      let headers = {
        'x-call-client-info': JSON.stringify(headerClientInfo),
      }
      this.submitFlag = true
      noTokenQuestionnaireAdd(headers, data).then((res) => {
        console.log(res)
        // this.checkStatus()
        if (res.code == 200) {
          this.submitFlag = false
          this.status = true
        } else {
          this.submitFlag = false
          this.$toast.fail(res.msg)
        }
      })
    },
    generateKey() {
      for (let val of this.customFiledArr) {
        val.nRules = []
        val.formKey = `formKey` + Math.floor(Math.random(30) * 1000000000)
        // val.valueData = this.generateRules(val)
        if (val.type == 'checkBox') {
          val.value = []
        }
        if (val.child && val.child.length > 0) {
          for (let sval of val.child) {
            sval.formKey = `${val.type == 'checkBox' ? 'checkBoxKey' : 'radioKey'}` + Math.floor(Math.random(30) * 1000000000)
          }
        }
      }
    },

    // 多选判断选择其他的情况处理逻辑
    checkBoxChange(value, index) {
      console.log(value)
      if (value.type == 'other') {
        if (this.customFiledArr[index].showInp) {
          this.customFiledArr[index].showInp = false
          this.customFiledArr[index].otherWord = ''
        } else {
          this.customFiledArr[index].showInp = true
        }
      }
    },
    radioChange(value, index) {
      console.log(value)
      if (value.type == 'other') {
        if (this.customFiledArr[index].showInp) {
          this.customFiledArr[index].showInp = false
          this.customFiledArr[index].otherWord = ''
          this.customFiledArr = JSON.parse(JSON.stringify(this.customFiledArr))
        } else {
          this.customFiledArr[index].showInp = true
          this.customFiledArr = JSON.parse(JSON.stringify(this.customFiledArr))
        }
      } else {
        this.customFiledArr[index].showInp = false
        this.customFiledArr[index].otherWord = ''
        this.customFiledArr = JSON.parse(JSON.stringify(this.customFiledArr))
      }
    },

    // 非空校验
    // 校验表单
    validateForm(arr) {
      let formResult = arr
      let bool = true
      for (let i in formResult) {
        console.log(formResult[i])
        if (formResult[i].required && (!formResult[i].value || formResult[i].value.length == 0)) {
          console.log(i)
          this.$dialog
            .alert({
              title: '提示',
              message: `请完成第${1 + Number(i)}题！`,
              theme: 'round-button',
            })
            .then(() => {
              // on close
            })
          bool = false
          break
        }
        if (formResult[i].type == 'checkBox' && formResult[i].showInp && !formResult[i].otherWord) {
          this.$dialog
            .alert({
              title: '提示',
              message: `请完成第${1 + Number(i)}题！,其他选项的输入不能为空`,
              theme: 'round-button',
            })
            .then(() => {
              // on close
            })
          bool = false
          break
        }
        // if (formResult[i].isIdNo && formResult[i].val.length < 6) {
        //   uni.showToast({
        //     title: `证件号码长度不能低于6位`,
        //     icon: 'none',
        //   })
        //   bool = false
        //   break
        // }
      }
      return bool
    },

    // 生成校验
    // generateRules(val) {
    //   if (val.type == 'input') {
    //     val.nRules[`${val.formKey}`] = [
    //       {
    //         required: true,
    //         message: val.message,
    //         trigger: 'blur',
    //       },
    //     ]
    //   }
    //   if (val.type != 'input') {
    //     val.nRules[`${val.formKey}`] = [
    //       {
    //         required: true,
    //         message: val.message,
    //         trigger: 'change',
    //       },
    //     ]
    //   }
    //   return val.nRules
    // },
  },
}
</script>


<style lang="less">
.staticQuestionaireBox{
  .el-checkbox{
    width: 100%;
    padding-left: 20px;
    display: flex;
    justify-content: left;
    margin-bottom: 10px;
    white-space: pre-wrap;
    .el-checkbox__input{
      white-space: pre-wrap;
    }
    .el-checkbox__label{
      width: 95%;
    }
  }
}
</style>

<style lang="less" scoped>
.container {
  background: #fff;  
  min-height: 100vh;
  width: 100vw;
  overflow: hidden;
}
@media screen and (max-width: 768px) {
  .demo-ruleForm {
    text-align: left;
    padding: 10px;
  }

  .topBox {
    width: 100%;
    min-height: 20vh;
    background-size: cover;
    background-repeat: no-repeat;

    .topImg {
      width: 100%;
      object-fit: contain;
    }

    .topCard {
      position: relative;
      top: -20px;
    }
  }
}
@media screen and (min-width: 768px) {
  .container {
    background: #f5f5f5;  
  }
  .demo-ruleForm {
    text-align: left;
    padding: 10px;
    width: 900px;
    margin: 100px auto 0;
    background-color: #fff;
  }

  .topBox {
    width: 100%;
    min-height: 20vh;
    background-size: cover;
    background-repeat: no-repeat;

    .topImg {
      width: 100%;
      object-fit: contain;
    }

    .topCard {
      position: relative;
      top: -20px;
    }
  }
}
@media screen and (min-width: 1920px) {
  .container {
    background: #f5f5f5;  
  }
  .demo-ruleForm {
    text-align: left;
    width: 1200px;
    margin: 60px auto 0;
  }
 }
</style>
